import CreateTaskModal from 'tasktracker/CreateTaskModal';
import { FC } from 'react';

const FakeCreateTaskModalRemote: FC<Parameters<typeof CreateTaskModal.CreateTaskModal>[0]> = () => {
  return null;
};

export const CreateTaskModalRemote = await import('tasktracker/CreateTaskModal')
  .then((res) => res.default.CreateTaskModal || FakeCreateTaskModalRemote)
  .catch(() => FakeCreateTaskModalRemote);
